// extracted by mini-css-extract-plugin
export var actionButton = "_be-0";
export var attachmentLine = "_be-1";
export var fileInput = "_be-2";
export var fileUploadWrapper = "_be-4";
export var footer = "_be-3";
export var modalContent = "_be-5";
export var paperclip = "_be-6";
export var quillEditor = "_be-7";